export const getDriverId = route => `${route.depotCode}*${route.driverCode}`;
